import { jsxs as m, jsx as e } from "react/jsx-runtime";
import { SolidCircleAlertIcon as t } from "../Icons/circle/SolidCircleAlertIcon.js";
const o = ({ error: r }) => {
  if (r)
    return /* @__PURE__ */ m("div", { className: "jm-font-label jm-flex jm-gap-1 jm-text-jutro-new-rose-600", children: [
      /* @__PURE__ */ e("div", { className: "jm-grid jm-h-6 jm-place-content-center", children: /* @__PURE__ */ e(t, { size: "sm" }) }),
      /* @__PURE__ */ e(
        "p",
        {
          className: "jm-m-0 jm-text-jutro-new-rose-800",
          dangerouslySetInnerHTML: { __html: r }
        }
      )
    ] });
};
export {
  o as ErrorMessage
};
//# sourceMappingURL=index.js.map
